import classNames from "classnames/bind";

import { ResolvedCopyOnly } from "resolvers/data/copyOnlyResolver";
import style from "./CopyModule.module.scss";
import RichText from "..";

const cx = classNames.bind(style);

export const CopyOnly = (props: ResolvedCopyOnly) => {
    return (
        <div
            className={cx("copyOnly")}
            style={{
                backgroundColor: props.backgroundColor,
                color: props.textForegroundColor,
            }}
        >
            <RichText {...props.content} />
        </div>
    );
};
